import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Row, Tooltip } from "antd";

const Label = () => {
  return (
    <Row style={{ alignItems: "center" }}>
      <span>Exterior Dimensions</span>
      <Tooltip color="#fff" title="length x width x height">
        <InfoCircleOutlined style={{ marginLeft: 5 }} />
      </Tooltip>
    </Row>
  );
};

export default Label;
